export const LOCAL_STORAGE_KEYS = {
  ALLOCATED_CASES_PAGE_REQUEST: 'ALLOCATED_CASES_PAGE_REQUEST',
  CURRENT_CASE_POINTER: 'CURRENT_CASE_POINTER',
  LAST_CHECKED_AT: btoa('LAST_CHECKED_AT'),
  EVENT_LIST: 'EVENT_LIST',
  FCM_TOKEN: 'FCM_TOKEN',
  LONGHORN_USER_HEARTBEAT: 'LONGHORN_USER_HEARTBEAT',
  LONGHORN_SESSION_TOKEN: 'LONGHORN_SESSION_TOKEN',
  AMEYO_INTERACTION_ID: 'AMEYO_INTERACTION_ID',
  LONGHORN_FIREBASE_TOKEN: 'LONGHORN_FIREBASE_TOKEN',
  AMEYO_CALL_RESET_FLAG: 'AMEYO_CALL_RESET_FLAG',
  LONGHORN_SESSION_IDENTIFIER: 'LONGHORN_SESSION_IDENTIFIER',
  ENABLE_PAYMENT_SUCCESS_MODAL: 'ENABLE_PAYMENT_SUCCESS_MODAL',
  IS_FIREBASE_SIGNED_IN: 'IS_FIREBASE_SIGNED_IN'
};

export const SESSION_STORAGE_KEYS = {
  INTERACTION_ID: 'INTERACTION_ID',
  TAB_ID: 'TAB_ID'
};
